import { DocumentOrganizationKeys } from '@griply/types';
import { useMemo } from 'react';
import { FilterDocuments } from 'shared/constants';
import { useUser } from 'shared/hooks/use-user';

export const useGoalsOverviewFilterDocument = () => {
  const user = useUser();
  return useMemo(
    () => ({
      ...FilterDocuments.GoalsOverview.defaultFilterDocument,
      ...(user?.settings?.filters?.goalsOverview ?? {}),
      [DocumentOrganizationKeys.SortingMode]:
        user?.settings?.filters?.goalsOverview?.[
          DocumentOrganizationKeys.SortingMode
        ] ??
        user?.settings?.goalSortingMode ??
        FilterDocuments.GoalsOverview.defaultFilterDocument[
          DocumentOrganizationKeys.SortingMode
        ],
      [DocumentOrganizationKeys.GroupByMode]:
        user?.settings?.filters?.goalsOverview?.[
          DocumentOrganizationKeys.GroupByMode
        ] ??
        user?.settings?.goalGroupBy ??
        FilterDocuments.GoalsOverview.defaultFilterDocument[
          DocumentOrganizationKeys.GroupByMode
        ],
    }),
    [
      user?.settings?.filters?.goalsOverview,
      user?.settings?.goalGroupBy,
      user?.settings?.goalSortingMode,
    ],
  );
};
